import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=0b2e06b7&"
import script from "./Heading.vue?vue&type=script&lang=ts&"
export * from "./Heading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports